import React, { useEffect, useState } from 'react';
import DataGridTable from '../../../Components/DataGrid';
import { StyledConfigurationContainer, StyledFlexEnd, StyledIndexContainerDiv, StyledLeadContainer } from '../../../Components/Styled';
import { Stack, Tooltip, Typography } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { emailWidth, handleValidateCodevalue, systemLookupCodeWidth } from '../../../Utility/constant';
import LookupCreateEditScreen from './CreateEditComponent';
import { useDispatch, useSelector } from 'react-redux';
import { handleRequestGetLookup } from '../../../Store/lookup/action';
import { handleCreateEditConfiguration, requestHideLoader, requestShowLoader } from '../../../Store/Global/action';
import tableBodyicon from '../../../Assets/images/tablebody_edit.png'
import tableEditicon from '../../../Assets/images/tableheader_edit.png';
import BiztantuLoader from '../../../Components/Loader';
export const ConfigurationLookup = ({}) => {

    const [currentActiveLookup, setCurrentActiveLookup] = useState({
        isEdit: false,
        activeLookupId: "",
        lookupTypeName: null
    });

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const [selectionModel, setSelectionModel] = React.useState([]);

    const dispatch = useDispatch();

    const lookupData = useSelector(state => state?.lookup?.allLookupData)?.map(item => ({...item, systemlookupcode: item?.codes?.map(nesteditem => nesteditem?.name)?.filter(Boolean)?.join(', ')}));

    useEffect(() => {
        handleGetLookups()
    },[])
    const handleGetLookups = async () => {
            const token = localStorage?.getItem('accessToken');
        try{
                
            dispatch(requestShowLoader())
            await dispatch(handleRequestGetLookup(token));
        }
        catch(error){
        }
        finally{
            dispatch(requestHideLoader())
        }
    }



    const handleDeleteLookup = () => {

    }

    const handleEditClick = (id) => () => {
        

        setCurrentActiveLookup({
            ...currentActiveLookup,
            isEdit: true,
            activeLookupId: id,
            lookupTypeName: lookupData?.find(item => item?.id == id)
        })

          dispatch(handleCreateEditConfiguration(true));

    }

     const handleBackButton = () => {
        setCurrentActiveLookup({
            ...currentActiveLookup,
            isEdit: false,
            activeLookupId: "",
            lookupTypeName: null
        })
        dispatch(handleCreateEditConfiguration(false));
    }

    const lookupcolumn = [
        

        {
            field: 'actions',
            type: 'actions',
            headerName: <Tooltip title={handleValidateCodevalue(internationalise,'COMMON_ACTION')} ><img src={tableEditicon} style={{paddingTop: "18px"}} /></Tooltip>,
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
            //   const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
      
            //   if (isInEditMode) {
            //     return [
            //       <GridActionsCellItem
            //         icon={<CheckIcon />}
            //         label="Save"
            //         className="textPrimary"
            //         onClick={handleSaveClick(id)}
            //       />,
            //       <GridActionsCellItem
            //         icon={<CancelIcon />}
            //         label="Cancel"
            //         className="textPrimary"
            //         onClick={handleCancelClick(id)}
            //         color="inherit"
            //       />,
            //     ];
            //   }
      
              return [
                <GridActionsCellItem
                  icon={<img src={tableBodyicon} />}
                  label={handleValidateCodevalue(internationalise,'COMMON_EDIT')}
                  className="textPrimary"
                  onClick={handleEditClick(id)}
                  color="inherit"
                />
                // <GridActionsCellItem
                //   icon={<DeleteIcon />}
                //   label="Edit"
                //   className="textPrimary"
                //   onClick={handleDeleteLookup(id)}
                //   color="inherit"
                // />,
              ];
            },
        },
        { 
            field: 'name', 
            headerName: handleValidateCodevalue(internationalise,'CONF_LU_SEARCH_NAME'),
            flex: 1,
            editable: false,
            minWidth : emailWidth
        },
        
        {
          field: 'systemlookupcode', 
          headerName: handleValidateCodevalue(internationalise,'CONF_LU_SEARCH_SLC'),
          flex: 1,
          editable: false,
          minWidth : systemLookupCodeWidth
        },
    ]


    const handleCreateLookup = () => {
        setCurrentActiveLookup({
            ...currentActiveLookup,
            isEdit: false,
            activeLookupId: "",
            lookupTypeName: null
        })
    }


    const isLoadingProgress = useSelector(state => state.global.isLoading); 
    return (
          <BiztantuLoader isChildren={true} open={isLoadingProgress}>
        <React.Fragment>
           
            {!currentActiveLookup?.isEdit && <StyledConfigurationContainer>
                <Typography variant='h6'>
                 {handleValidateCodevalue(internationalise,'CONF_LU_SEARCH_TITLE')}
                 </Typography>
            
            </StyledConfigurationContainer>}
                        
            {!currentActiveLookup?.isEdit && <><StyledFlexEnd>
            </StyledFlexEnd>
            <StyledIndexContainerDiv>
                <StyledLeadContainer>
                    <Stack spacing={2} width="40%" direction="row">
                    </Stack>
                </StyledLeadContainer>
            
            {/* <ConfigurationLookupSearch /> */}
            
            <DataGridTable 
                isCheckboxReq={false}
                columns={lookupcolumn}
                height={"calc(100vh - 209px)"}
                marginTop='0px'
                selectionModel={selectionModel}
                setSelectionModel={(data) => setSelectionModel(data)}
                dataGridData={lookupData}
            /></StyledIndexContainerDiv>
</>}

            {currentActiveLookup?.isEdit && <LookupCreateEditScreen
                currentActiveLookup = {currentActiveLookup}
                handleCustomBackbutton = {handleBackButton}
                
            />}

        </React.Fragment>
        </BiztantuLoader>
    )
}


export default ConfigurationLookup;